module.exports = __webpack_public_path__ + "img/yellow.e5a7f3f2.svg";